<ng-container *ngIf="!ready">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
<ng-container *ngIf="ready">
  <p><strong>Asignar partner a usuario</strong></p>
  <hr>
  <app-select name="advisorUid" [(ngModel)]="advisorUid"
    [config]="{ placeholder: 'Partner', options: advisorsOptions }">
  </app-select>
  <br />

  <div class="d-flex justify-content-center flex-column flex-md-row">
    <button mat-stroked-button (click)="assign()" class="me-0 me-md-2 mb-2 mb-md-0">Asignar</button>
    <button mat-stroked-button (click)="closeDialog()">
      <mat-icon>close</mat-icon>
      Cerrar
    </button>
  </div>

</ng-container>